import { ReactComponent as CrossIcon } from 'icons/cross.svg';
import NextButton from 'Domains/Step/atoms/NextButton';
import useTranslation from 'shared/useTranslation';
import * as S from '../SummaryPayment/organisms/RemoveCardConfirmationPopup/styles';
import { getPriceChangedTextValues } from './utils';

export interface PriceChangedPopupProps {
  open: boolean;
  postedPriceCents: number;
  serverPriceCents: number;
  onBack: () => void;
  onConfirm: () => void;
}

const PriceChangedPopup = ({ open, postedPriceCents, serverPriceCents, onBack, onConfirm }: PriceChangedPopupProps) => {
  const [translations, t] = useTranslation([
    'widget.step.summary.price.changed.title',
    'widget.step.summary.price.changed.confirm',
    'widget.step.summary.price.changed.back',
  ] as const);
  const priceTextValues = getPriceChangedTextValues({ postedPriceCents, serverPriceCents });

  return (
    <S.DialogWrapper onClose={onBack} open={open} fullWidth>
      <S.DialogHeader>
        <S.Title>{translations.widgetStepSummaryPriceChangedTitle}</S.Title>
        <CrossIcon onClick={onBack} />
      </S.DialogHeader>
      <S.DialogContentWrapper>
        {t('widget.step.summary.price.changed.description', priceTextValues)}
      </S.DialogContentWrapper>
      <S.DialogActionsWrapper>
        <NextButton color="primary" variant="contained" onClick={onConfirm}>
          {translations.widgetStepSummaryPriceChangedConfirm}
        </NextButton>
        <S.BackButton onClick={onBack}>{translations.widgetStepSummaryPriceChangedBack}</S.BackButton>
      </S.DialogActionsWrapper>
    </S.DialogWrapper>
  );
};

export default PriceChangedPopup;
